module.exports = __webpack_public_path__ + "img/back7.380a4ce6.jpg";